import { BaseEntity } from "yt-ng-framework";

export class PodVrstaDokumentaView extends BaseEntity{
    constructor(){
        super();
    }

    VrstaDokumenta:string;    
    GenericName:string;
    Naziv:string;    
    SNaziv:string;
    IsActive:boolean;
    DefaultIzvestajID: number = null;
    OdgovornoLiceJeObavezno: boolean = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.VrstaDokumenta=input.VrstaDokumenta;
        this.GenericName=input.GenericName;
        this.Naziv=input.Naziv;       
        this.SNaziv=input.SNaziv;
        this.IsActive = input.IsActive;
        this.DefaultIzvestajID = input.DefaultIzvestajID;
        this.OdgovornoLiceJeObavezno = input.OdgovornoLiceJeObavezno;
        return this;
    }

    Serialize(input:PodVrstaDokumentaView){
        return input;
    }
}